"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pcbLayoutNestedNodeDelimiter = exports.pcbLayoutRootNodeParentId = exports.pcbLayoutRootNodeId = exports.PcbNodeTypes = void 0;
exports.isDeprecatedPcbNodeType = isDeprecatedPcbNodeType;
const constants_1 = require("../../document/constants");
/**
 * This file defines interface that are base to build up interfaces for a PcbLayoutNode
 */
var PcbNodeTypes;
(function (PcbNodeTypes) {
    PcbNodeTypes["root"] = "root";
    PcbNodeTypes["layout"] = "layout";
    PcbNodeTypes["element"] = "element";
    PcbNodeTypes["via"] = "via";
    PcbNodeTypes["routeSegment"] = "routeSegment";
    PcbNodeTypes["pad"] = "pad";
    PcbNodeTypes["footprint"] = "footprint";
    PcbNodeTypes["model"] = "model";
    PcbNodeTypes["container"] = "container";
    PcbNodeTypes["group"] = "group";
    PcbNodeTypes["text"] = "text";
    PcbNodeTypes["line"] = "line";
    PcbNodeTypes["circle"] = "circle";
    PcbNodeTypes["rectangle"] = "rectangle";
    PcbNodeTypes["net"] = "net";
    PcbNodeTypes["fill"] = "fill";
    PcbNodeTypes["zone"] = "zone";
    PcbNodeTypes["smartVia"] = "smartVia";
    PcbNodeTypes["polygon"] = "polygon";
})(PcbNodeTypes || (exports.PcbNodeTypes = PcbNodeTypes = {}));
function isDeprecatedPcbNodeType(nodeType) {
    return nodeType === "route";
}
// This node ID should only be used as the uid of the root node, and of the
// parentUid of direct children of the root node.
exports.pcbLayoutRootNodeId = "ROOT";
// This node ID should only be used as the parentUid of the root node.
exports.pcbLayoutRootNodeParentId = "PARENT_OF_ROOT";
// QUESTION: why not rename all to nestedNodeDelimiter?
exports.pcbLayoutNestedNodeDelimiter = constants_1.nestedNodeDelimiter;
//# sourceMappingURL=structure.js.map